import { CSSProperties } from 'react';
import colors from '../../../../../utils/colors';

export default {
    container: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        margin: 20
    },
    titleRow: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingRight: 12,
        paddingTop: 8,
        paddingBottom: 8,
        cursor: 'pointer'
    },
    title: {
        fontSize: 18,
        color: colors.title,
        fontWeight: 'bold'
    },
    stepsContainer: {
        position: 'relative',
        overflow: 'hidden',
        transition: 'max-height 0.5s ease'
    },
    stepItem: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row',
        marginTop: 20,
        color: colors.title,
        alignItems: 'center'
    },
    stepNode: {
        width: 12,
        height: 12,
        borderRadius: 6,
        backgroundColor: '#ccc',
        marginRight: 12
    },
    step: {
        fontSize: 14,
        fontWeight: 'bold'
    },
    time: {
        position: 'absolute',
        right: 0,
        fontSize: 14,
        color: colors.paragraph
    },
    sideLine: {
        position: 'absolute',
        top: 30,
        bottom: 10,
        left: 5.5,
        width: 1,
        backgroundColor: '#ccc'
    }
} as Record<string, CSSProperties>;
